import React from "react";

export default function PublicCatalogLoadingPage() {
    return (
        <div style={styles.wrap}>
            <div style={styles.card}>
                <div style={styles.title}>Carregando catálogo...</div>
                <div style={styles.sub}>
                    Aguarde enquanto localizamos a Revendedora.
                </div>
            </div>
        </div>
    );
}

const styles = {
    wrap: {
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 16,
        background: "linear-gradient(180deg, rgba(144,35,72,0.08), #f6f7fb 220px)",
    },
    card: {
        width: "100%",
        maxWidth: 480,
        background: "#fff",
        borderRadius: 20,
        padding: 24,
        border: "1px solid rgba(17,24,39,0.08)",
        boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
        textAlign: "center",
    },
    title: {
        fontSize: 22,
        fontWeight: 900,
        color: "#111827",
    },
    sub: {
        marginTop: 10,
        color: "#4b5563",
        fontWeight: 600,
    },
};